import React, { useRef, useEffect } from "react";
import wipro from "../assets/logos/wipro.svg";
import haldirams from "../assets/logos/haldirams.svg";
import goodGlam from "../assets/logos/good-glam.svg";
import himalaya from "../assets/logos/himalaya.svg";
import barbequeNation from "../assets/logos/barbeque-nation.svg";
import symphony from "../assets/logos/symphony.svg";
import yesMadam from "../assets/logos/yes-madam.svg";
import zouk from "../assets/logos/zouk.svg";
import vastranand from "../assets/logos/vastranand.svg";
import sassafras from "../assets/logos/sassafras.svg";
import royaloak from "../assets/logos/royaloak.svg";
import imarticusLearning from "../assets/logos/imarticus-learning.svg";
import flo from "../assets/logos/flo.svg";
import elysiannGlorry from "../assets/logos/elysiann-glorry.svg";
import peeSafe from "../assets/logos/pee-safe.svg";
import assembly from "../assets/logos/assembly.svg";
import cea from "../assets/logos/cea.svg";
import caarabi from "../assets/logos/caarabi.svg";
import azafran from "../assets/logos/azafran.svg";
import astrotalk from "../assets/logos/astrotalk.svg";

const BrandLogoCarousel = () => {
  // 👇 Each logo can define custom width/height if needed
  const images = [
    { src: wipro, intrinsicWidth: 278, intrinsicHeight: 223 },
    { src: haldirams, intrinsicWidth: 320, intrinsicHeight: 175 },
    { src: barbequeNation, intrinsicWidth: 365, intrinsicHeight: 227 },
    {
      src: imarticusLearning,
      width: "200px",
      intrinsicWidth: 509,
      intrinsicHeight: 120,
    },
    { src: peeSafe, intrinsicWidth: 359, intrinsicHeight: 255 },
    { src: zouk, intrinsicWidth: 427, intrinsicHeight: 140 },
    { src: yesMadam, intrinsicWidth: 427, intrinsicHeight: 203 },
    { src: flo, width: "100px", intrinsicWidth: 343, intrinsicHeight: 241 },
    { src: assembly, width: "180px", intrinsicWidth: 690, intrinsicHeight: 76 },
    { src: caarabi, width: "150px", intrinsicWidth: 470, intrinsicHeight: 136 },
    { src: vastranand, width: "240px", intrinsicWidth: 915, intrinsicHeight: 140 },
    { src: goodGlam, intrinsicWidth: 396, intrinsicHeight: 215 },
    { src: himalaya, width: "150px", intrinsicWidth: 380, intrinsicHeight: 137 },
    { src: royaloak, width: "180px", intrinsicWidth: 455, intrinsicHeight: 180 },
    { src: azafran, intrinsicWidth: 422, intrinsicHeight: 198 },
    { src: symphony, width: "170px", intrinsicWidth: 536, intrinsicHeight: 151 },
    { src: sassafras, width: "170px", intrinsicWidth: 458, intrinsicHeight: 88 },
    { src: cea, intrinsicWidth: 354, intrinsicHeight: 322 },
    {
      src: elysiannGlorry,
      width: "190px",
      intrinsicWidth: 523,
      intrinsicHeight: 194,
    },
    { src: astrotalk, width: "190px", intrinsicWidth: 826, intrinsicHeight: 195 },
  ];

  const scrollSpeed = 0.5;
  const defaultWidth = "120px";
  const gap = 80;

  const scrollRef = useRef(null);
  const speedRef = useRef(scrollSpeed);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const startScroll = useRef(0);

  const clones = [...images, ...images, ...images];
  const parseSize = (value) =>
    typeof value === "string" ? parseInt(value, 10) : value;

  // --- Auto-scroll animation ---
  // useEffect(() => {
  //   let rafId;
  //   const loop = () => {
  //     const slider = scrollRef.current;
  //     if (slider && !isDragging.current) {
  //       slider.scrollLeft += speedRef.current;
  //       const blockWidth = slider.scrollWidth / 3;
  //       if (slider.scrollLeft >= blockWidth) slider.scrollLeft -= blockWidth;
  //     }
  //     rafId = requestAnimationFrame(loop);
  //   };
  //   rafId = requestAnimationFrame(loop);
  //   return () => cancelAnimationFrame(rafId);
  // }, []);

  // useEffect(() => {
  //   let rafId;
  //   let preciseScroll = 0;

  //   const loop = () => {
  //     const slider = scrollRef.current;

  //     if (slider && !isDragging.current) {
  //       preciseScroll += speedRef.current;

  //       const move = Math.floor(preciseScroll);
  //       preciseScroll -= move;

  //       slider.scrollLeft += move;

  //       const blockWidth = slider.scrollWidth / 3;
  //       if (slider.scrollLeft >= blockWidth) {
  //         slider.scrollLeft -= blockWidth;
  //       }
  //     }

  //     rafId = requestAnimationFrame(loop);
  //   };

  //   rafId = requestAnimationFrame(loop);
  //   return () => cancelAnimationFrame(rafId);
  // }, []);

  useEffect(() => {
    let rafId;
    let position = 0;

    const loop = () => {
      const slider = scrollRef.current?.firstChild;
      if (slider && !isDragging.current) {
        position += speedRef.current;

        const blockWidth = slider.scrollWidth / 3;

        if (position >= blockWidth) {
          position -= blockWidth;
        }

        slider.style.transform = `translateX(${-position}px)`;
      }

      rafId = requestAnimationFrame(loop);
    };

    rafId = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafId);
  }, []);

  // --- Drag-to-scroll ---
  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider) return;
    const preventDefaultDrag = (e) => e.preventDefault();
    slider.addEventListener("dragstart", preventDefaultDrag);

    const onPointerDown = (e) => {
      isDragging.current = true;
      try {
        slider.setPointerCapture(e.pointerId);
      } catch {}
      startX.current = e.clientX;
      startScroll.current = slider.scrollLeft;
      speedRef.current = 0;
      slider.classList.add("cursor-grabbing");
    };
    const onPointerMove = (e) => {
      if (!isDragging.current) return;
      e.preventDefault();
      const dx = e.clientX - startX.current;
      slider.scrollLeft = startScroll.current - dx * 1.5;
    };
    const onPointerUp = (e) => {
      isDragging.current = false;
      try {
        slider.releasePointerCapture(e.pointerId);
      } catch {}
      speedRef.current = scrollSpeed;
      slider.classList.remove("cursor-grabbing");
    };

    slider.addEventListener("pointerdown", onPointerDown);
    slider.addEventListener("pointermove", onPointerMove);
    slider.addEventListener("pointerup", onPointerUp);
    slider.addEventListener("pointercancel", onPointerUp);
    slider.addEventListener("pointerleave", onPointerUp);

    return () => {
      slider.removeEventListener("dragstart", preventDefaultDrag);
      slider.removeEventListener("pointerdown", onPointerDown);
      slider.removeEventListener("pointermove", onPointerMove);
      slider.removeEventListener("pointerup", onPointerUp);
      slider.removeEventListener("pointercancel", onPointerUp);
      slider.removeEventListener("pointerleave", onPointerUp);
    };
  }, [scrollSpeed]);

  // --- Pause on hover ---
  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider) return;
    const pause = () => (speedRef.current = 0);
    const resume = () => (speedRef.current = scrollSpeed);
    slider.addEventListener("mouseenter", pause);
    slider.addEventListener("mouseleave", resume);
    return () => {
      slider.removeEventListener("mouseenter", pause);
      slider.removeEventListener("mouseleave", resume);
    };
  }, [scrollSpeed]);

  return (
    <div className="relative w-full mt-[25px]">
      {/* <div
        ref={scrollRef}
        className="hide-scrollbar flex overflow-x-auto whitespace-nowrap items-center px-4 cursor-grab select-none"
        style={{ touchAction: "none", gap: `${gap}px` }}
      > */}
      <div
        ref={scrollRef}
        className="hide-scrollbar overflow-hidden px-4 cursor-grab select-none"
      >
        <div
          className="flex whitespace-nowrap items-center"
          style={{ gap: `${gap}px` }}
        >
          {clones.map((item, i) => (
            (() => {
              const renderedWidth =
                parseSize(item.width) || parseSize(defaultWidth);
              const renderedHeight =
                parseSize(item.height) ||
                Math.round(
                  (renderedWidth * item.intrinsicHeight) / item.intrinsicWidth
                );

              return (
                <img
                  key={i}
                  src={item.src}
                  alt={`brand-${i}`}
                  width={renderedWidth}
                  height={renderedHeight}
                  draggable={false}
                  className="object-contain opacity-90 hover:opacity-100 transition-all duration-300 inline-block"
                  style={{
                    height: item.height,
                    width: item.width || defaultWidth,
                    flexShrink: 0,
                  }}
                />
              );
            })()
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandLogoCarousel;
